import { useEffect, useState } from "react";
import { getVisibleTextContent } from "./helpers";

export function useProxyDisplay<T extends HTMLElement>(getElement: () => T) {
  const [display, setDisplay] = useState('');
  useEffect(() => {
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        const element = mutation.target as T;
        setDisplay(getVisibleTextContent(element));
      }
    });

    const element = getElement();
    observer.observe(element, { childList: true, attributes: true, attributeFilter: ['aria-hidden'] });
    setDisplay(getVisibleTextContent(element));

    return () => observer.disconnect();
  }, [getElement])
  return display;
}
